module.exports = __webpack_public_path__ + "static/media/manovr-2.7f363c8d.jpg";